if (!customElements.get('adored-vision-panels')) {
  class AdoredVisionPanels extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const opener = event.target.closest('[data-av-open]');
        if (opener) {
          const dialog = document.getElementById(opener.dataset.avOpen);
          if (!dialog || dialog.open) return;
          this.returnFocus = opener;
          this.previousOverflow = document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
        }
        const closer = event.target.closest('[data-av-close]');
        if (closer) closer.closest('dialog').close();
      });
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => {
          document.body.style.overflow = this.previousOverflow || '';
          this.returnFocus?.focus();
        });
      });
    }
    disconnectedCallback() {
      if (this.querySelector('dialog[open]')) document.body.style.overflow = this.previousOverflow || '';
    }
  }
  customElements.define('adored-vision-panels', AdoredVisionPanels);
}


// Mark the section currently in view without changing browser history.
function adoredExploreNavigation() {
  const nav = document.querySelector('[data-av-nav]');
  if (!nav || nav.dataset.ready || !('IntersectionObserver' in window)) return;
  nav.dataset.ready = 'true';
  const links = [...nav.querySelectorAll('a[href^="#"]')];
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      links.forEach(link => {
        if (link.hash === '#' + entry.target.id) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    });
  }, { rootMargin: '-70px 0px -60% 0px', threshold: 0 });
  links.forEach(link => { const target = document.getElementById(link.hash.slice(1)); if (target) observer.observe(target); });
}
adoredExploreNavigation();
document.addEventListener('shopify:section:load', adoredExploreNavigation);


// Keep section links below the visible header, including Eurus' scroll-up header.
function adoredHeaderOffset() {
  if (!document.querySelector('.av-navigation-section') || document.documentElement.dataset.avOffsetReady) return;
  document.documentElement.dataset.avOffsetReady = 'true';
  let scheduled = false;
  let settled;
  const update = () => {
    const header = document.querySelector('header.header');
    const rect = header?.getBoundingClientRect();
    const offset = rect && rect.top <= 0 && rect.bottom > 0 ? Math.min(rect.bottom, rect.height) : 0;
    document.documentElement.style.setProperty('--av-header-offset', Math.round(offset) + 'px');
    scheduled = false;
  };
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } clearTimeout(settled); settled = setTimeout(update, 350); };
  window.addEventListener('scroll', schedule, {passive:true});
  window.addEventListener('resize', schedule);
  update();
}
adoredHeaderOffset();
document.addEventListener('shopify:section:load', adoredHeaderOffset);
// The native quantity control uses the same label on both buttons.
if (document.querySelector('.av-story')) {
  document.querySelectorAll('.main-product .x-quantity-selector button[name="plus"]').forEach(button => button.setAttribute('aria-label', 'Increase quantity'));
  document.querySelectorAll('.main-product .x-quantity-selector button[name="minus"]').forEach(button => button.setAttribute('aria-label', 'Decrease quantity'));
}
